import React, { ReactNode } from 'react';
import { Icon } from '../../components';
import { SSpinner } from './styled/SLoading';

interface LoadingProps {
    children?: ReactNode;
    color?: string;
    width?: number;
    height?: number;
}

function Loading(props: LoadingProps) {
    return <SSpinner color={props.color || ''}><Icon name="spinner" width={props.width || 16} height={props.height || 16}/>{props.children}</SSpinner>
}

export default Loading;